"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioGroup = void 0;
const react_1 = __importStar(require("react"));
const UiKitLite_1 = require("../UiKitLite");
const RadioGroup = () => {
    let City;
    (function (City) {
        City["Paris"] = "Paris";
        City["Venice"] = "Venice";
        City["Santorini"] = "Santorini";
    })(City || (City = {}));
    const [radioValue, setRadioValue] = (0, react_1.useState)(City.Paris);
    const options = [
        {
            text: 'Paris',
            helpText: 'Paris is the capital of France.',
            value: City.Paris,
        },
        {
            text: 'Venice',
            helpText: 'Venice is a city in Italy.',
            value: City.Venice,
        },
        {
            text: 'Santorini',
            helpText: 'Santorini is a city in Greece.',
            value: City.Santorini,
        },
    ];
    return (react_1.default.createElement(UiKitLite_1.UiKitLite.Form.RadioGroup, { options: options, value: radioValue, onChange: (e) => setRadioValue(e) }));
};
exports.RadioGroup = RadioGroup;
